module.exports = " <p-select :model.sync=model @on-change=onChange :rules=rules :multiple=multiple :filterable=filterable :clearable=clearable :disabled=disabled :placeholder=placeholder :size=size :placement=placement :render-format=renderFormat> <p-option :value=it.orgUnitId :label=it.orgUnitName v-for=\"it in list\" track-by=$index :disabled=!canSelect(it)>{{{it.vmOrgUnitName}}}</p-option> </p-select> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/org-check/org-check.vue
// module id = 306
// module chunks = 0